export default __webpack_public_path__ + "static/workforce-b12818295fd667beba1221347f984005.webp";